import { render, staticRenderFns } from "./DefaultMessageEditView.vue?vue&type=template&id=1fcdb428"
import script from "./DefaultMessageEditView.vue?vue&type=script&lang=js"
export * from "./DefaultMessageEditView.vue?vue&type=script&lang=js"
import style0 from "./DefaultMessageEditView.vue?vue&type=style&index=0&id=1fcdb428&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports